import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-head-img',
  templateUrl: './offline-head-img.component.html',
  styleUrls: ['./offline-head-img.component.scss']
})
export class OfflineHeadImgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
